module.exports = __webpack_public_path__ + "static/img/01.c94eca5e.png";